<template>
<div style="display:flex;flex-direction:column;height:100%">
<v-toolbar dark class="primary">
    <v-btn @click.native="$router.push('/home')" icon>
        <v-icon>chevron_left</v-icon>
    </v-btn>        
    <v-toolbar-title>Settings</v-toolbar-title>
    <v-spacer></v-spacer>
    <v-btn icon>
        <v-icon>search</v-icon>
    </v-btn>
    <v-btn icon>
        <v-icon>more_vert</v-icon>
    </v-btn>
</v-toolbar>  
    <LayoutPanel :tree="page"/>
<!-- <div style="height:300px">
</div> -->

</div>
</template>

<script>
    //import LayoutPanel from '../ui-elements/LayoutPanel'
    export default {
        name: 'Template',
        data() {
            return {
                page: {
                    panel: {
                        name: 'master_panel',
                        hasColumns: true,
                    },
                    panels: [
                        {
                            panel: {
                                name: 'left_column',
                                scroll: true,
                                placeholderText: true,
                            }
                        },
                        {
                            panel: {
                                name: 'right_column',
                            },
                            panels: [
                                {
                                    panel: {
                                        name: 'upper_row',
                                        hasColumns: true,
                                    },
                             
                                    panels: [
                                        {
                                            panel: {
                                                name: 'upper_left',
                                                placeholderText: true,
                                            }
                                        },
                                        {
                                            panel: {
                                                name: 'upper_right',
                                                placeholderText: true,
                                            }
                                        },
                                    ]                                    
                                },
                                {
                                    panel: {
                                        name: 'lower_row',
                                        placeholderText: true,
                                    }
                                },
                            ]

                        },
                    ]
                }

            }
        },
        components: {
            // LayoutPanel
        },
        computed:{

        },
        methods: {

        }
    }

</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>

</style>


// WEBPACK FOOTER //
// Settings.vue?9063337a